import { usePwa } from 'src/contexts/pwa-context'

export const usePwaInstall = () => usePwa()
